module.exports = __webpack_public_path__ + "img/gift.7df0fca0.png";